$(document).ready(function () {

    document.querySelector("#main-menu").addEventListener("click", function () {
        toggleHamburger();
    }, !1)

    if ($(window).width() < 1251 && document.querySelector(".insights_sub_menu")) {
        $("#orangeMenu").on("click", () => {
            //If any of the larger menus are open, this menu will close
            if ($(".main-menu-language-switcher").hasClass("open") || $("#main-menu").hasClass("is-active") || !$("#orangeMenu").hasClass("is-active")) {
                document.querySelector(".insights_sub_menu").style = "height: auto !important;";
                $("html").css("overflow", "unset");
            }
            else {
                document.querySelector(".insights_sub_menu").style = "height: calc(100vh - 59px) !important; max-height: calc(100vh - 58px) !important;";
                //Stoping body scroll
                $("html").css("overflow", "hidden");
            }
        })
    }
    $(".headerWrapper .hamburger").click(function () {
        if ($(".insights_sub_menu .sidepanel_mobile ul").css('display') === 'block') {
            $("#orangeMenu").click();
        }
        if ($("#menu-research-menu-1").css('display') === 'block') {
            $(".green_hamburger").click()
        }
        if ($('.side-menu .current-menu-item').length) {
            toggleSubMenu($('.side-menu .current-menu-item>a')[0]);
        }
        closeAllSubMenus();
        $('.mainMenuWrapper').slideToggle(230);
        $('.mainMenuWrapper').toggleClass('collapsed');
    });

    $('.product-menu .hamburger').click(function () {
        var productMenu = $('#geoplast-product-menu-collapse');
        var productMenuHeight = $(window).height() - $('.headerWrapper').height() - $('.product-menu.page').height();
        productMenu.css({
            maxHeight: productMenuHeight + 'px',
            overflowY: 'auto'
        });
        productMenu.toggleClass('collapsed');
        productMenu.slideToggle(230);
    });


    $("#menu-nav-1 li a").on("click",function (e) {
        //START zatvatrnje nav menija prilikom klika na neki link
        toggleHamburger();
        if ($(".insights_sub_menu .sidepanel_mobile ul").css('display') === 'block') {
            $("#orangeMenu").click();
        }
        if ($("#menu-research-menu-1").css('display') === 'block') {
            $(".green_hamburger").click()
        }
        if ($('.side-menu .current-menu-item').length) {
            toggleSubMenu($('.side-menu .current-menu-item>a')[0]);
        }
        closeAllSubMenus();
        $('.mainMenuWrapper').slideToggle(230);
        $('.mainMenuWrapper').toggleClass('collapsed');
        //     //END zatvatrnje nav menija prilikom klika na neki link
    })

});


function toggleHamburger(){
    document.querySelector("#main-menu").classList.toggle("is-active");
}


function closeAllSubMenus() {
    const topLevelLinksWithSubMenus = $('header .menu>.menu-item:has(> ul.sub-menu)');
    topLevelLinksWithSubMenus.each(function () {
        const subMenu = $(this.children[1]);
        $(subMenu).css('display', 'none');
    });
}

function clearHoverColorOnAllLinks() {
    const topLevelLinksWithSubMenus = $('.menu>.menu-item:has(> ul.sub-menu)');
    topLevelLinksWithSubMenus.each(function () {
        $(this.children[0]).removeClass('current-selected');
    });
}

function toggleSubMenu(element) {
    console.log("toggle element line 130", element);
    const isOpen = $(element.nextElementSibling).css('display') === 'block',
        setDisplay = isOpen ? 'none' : 'block';
    //close opened sub-menus to open clicked one
    if (!isOpen) {
        closeAllSubMenus();
    }
    $(element.nextElementSibling).css('display', setDisplay);
}

function handleHoverColorPersistenceOnClickedLink() {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        activeLinks = $('.contentWrapper .current-menu-item>a');
    let screen = viewportWidth < 1075 ? 1 : 0;

    if (activeLinks.length) {
        screen = activeLinks[screen] ? screen : 0;
        //lowest level links, product/download
        if (!$(activeLinks[screen]).siblings().length && (activeLinks[screen] && $(activeLinks[screen])[0].parentElement.parentElement.tagName !== 'SECTION')) {
            const categoryLink = activeLinks[screen].parentElement.parentElement.parentElement,
                topLevelLink = activeLinks[screen].parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;

            if (!activeLinks[screen].parentElement.classList.contains('menu-item-object-downloads')) {
                $(categoryLink).addClass('current-menu-item');
            }
            $(topLevelLink).addClass('current-menu-item');
        }
        else if ($(activeLinks[screen])[0].parentElement.parentElement.tagName === 'SECTION') {//category links, product/solutions
            const topLevelLink = $(activeLinks[screen])[0].parentElement.parentElement.parentElement.parentElement
            $(topLevelLink).addClass('current-menu-item');
        }
    }


}    

// document.addEventListener("DOMContentLoaded", function() {
//     const sideMenu = document.getElementById("geoplast-collapse");
//     const menuButton = document.getElementById("main-menu");

//     function closeMenu() {
//         sideMenu.classList.remove("collapsed");
//     }

//     document.addEventListener("click", function(event) {
       

//         if (!sideMenu.contains(event.target) && !menuButton.contains(event.target) && sideMenu.classList.contains("collapsed")) {
//             closeMenu();
            
//             toggleHamburger();
//         }
//     });

    
// });




